import React, { useState, useEffect } from "react";
import styles from "../css/styles.module.css";
import { functions } from "../config/firebase.js";
import loadingIcon from "../images/loading.gif";

export default function User(props) {
  const addAdmin = functions.httpsCallable("addAdmin");
  const addUser = functions.httpsCallable("addUser");
  const [user, setUser] = useState(() => {
    return {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    };
  });
  const [adminEmail, setAdminEmail] = useState("");
  const [adminMessage, setAdminMessage] = useState(null);
  const [userMessage, setUserMessage] = useState(null);
  const [adminLoading, setAdminLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);

  useEffect(() => {}, []);

  function handleUserOnChange(e) {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  }

  function handleAdminOnChange(e) {
    setAdminEmail(e.target.value);
  }

  function handleUserSubmit(e) {
    setUserLoading(true);
    e.preventDefault();
    setUserMessage({});
    if (user.password === user.confirmPassword) {
      addUser({
        email: user.email,
        password: user.password,
        displayName: user.name,
      }).then((result) => {
        setUserLoading(false);
        if (result.data.message === "Error") {
          setUser((prevState) => {
            return {
              ...prevState,
              password: "",
              confirmPassword: "",
            };
          });
          setUserMessage({
            message: result.data.code.errorInfo.message,
            error: true,
          });
        } else {
          setUser({
            name: "",
            email: "",
            password: "",
            confirmPassword: "",
          });
          setUserMessage({
            message: "User created successfully",
            error: false,
          });
        }
      });
    } else {
      setUserLoading(false);
      setUser((prevState) => {
        return {
          ...prevState,
          password: "",
          confirmPassword: "",
        };
      });
      setUserMessage({
        message: "Password did not match",
        error: true,
      });
    }
  }

  function handleAdminSubmit(e) {
    setAdminLoading(true);
    setAdminMessage({});
    e.preventDefault();
    addAdmin({ email: adminEmail }).then((result) => {
      setAdminEmail("");
      setAdminLoading(false);
      if (result.data.message === "Error") {
        setAdminMessage({
          message: result.data.code.errorInfo.message,
          error: true,
        });
      } else {
        setAdminMessage({
          message: result.data,
          error: false,
        });
      }
    });
  }

 if(props.isAdmin){
  return (
    <div className={styles.addContainer}>
      <form className={styles.form} onSubmit={handleUserSubmit}>
        <h1>Add new user</h1>
        <input
          name="name"
          type="text"
          placeholder="Display Name"
          onChange={handleUserOnChange}
          value={user.name}
          required
        ></input>
        <input
          name="email"
          type="email"
          placeholder="Email"
          onChange={handleUserOnChange}
          value={user.email}
          required
        ></input>
        <input
          name="password"
          type="password"
          placeholder="Password"
          onChange={handleUserOnChange}
          value={user.password}
          required
        ></input>
        <input
          name="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          onChange={handleUserOnChange}
          value={user.confirmPassword}
          required
        ></input>
        <button type="submit">Create User</button>
        {userLoading && (
          <img src={loadingIcon} className={styles.loadingIcon} alt="Loading" />
        )}
        {userMessage != null && (
          <p className={userMessage.error ? styles.error : styles.success}>
            {userMessage.message}
          </p>
        )}
      </form>
      <form className={styles.form} onSubmit={handleAdminSubmit}>
        <h1>Make admin</h1>
        <input
          name="email"
          type="email"
          placeholder="Email"
          onChange={handleAdminOnChange}
          value={adminEmail}
          required
        ></input>
        <button type="submit">Make admin</button>
        {adminLoading && (
          <img src={loadingIcon} className={styles.loadingIcon} alt="Loading"/>
        )}
        {adminMessage != null && (
          <p className={adminMessage.error ? styles.error : styles.success}>
            {adminMessage.message}
          </p>
        )}
      </form>
    </div>
  );
 } else {
   return (
     <div></div>
   );
 }
}
